(function () {
  function initSlider(wrap) {
    if (wrap.dataset.initialized) return;
    wrap.dataset.initialized = '1';

    var slider = wrap.querySelector('.qty-slider');
    var labels = wrap.querySelectorAll('.pack-label');
    var disp   = wrap.querySelector('.qty-slider-display');
    var ids    = (wrap.dataset.ids    || '').split(',').filter(Boolean);
    var prices = (wrap.dataset.prices || '').split('|').filter(Boolean);
    var sid    = wrap.dataset.section || '';
    var total  = Math.max(0, ids.length - 1);

    if (!slider || ids.length === 0) return;

    // Insert summary label above the slider
    var summaryEl = document.createElement('div');
    summaryEl.className = 'pack-summary';
    wrap.insertBefore(summaryEl, wrap.firstChild);

    // Find the product info container this slider lives in
    var container = wrap.closest('.product__info-container') || wrap.closest('form') || document.body;

    function update(idx) {
      idx = parseInt(idx, 10);
      slider.style.setProperty('--qty-fill', (total > 0 ? idx / total * 100 : 0) + '%');
      labels.forEach(function (l, i) { l.classList.toggle('active', i === idx); });
      if (disp && prices[idx]) disp.textContent = prices[idx];

      // Update summary label
      if (summaryEl && prices[idx]) {
        var qty      = parseInt((labels[idx] && labels[idx].textContent) || '1', 10) || 1;
        var priceNum = parseFloat(prices[idx].replace(/[^0-9.]/g, ''));
        var perUnit  = (priceNum / qty).toFixed(2);
        var plural   = qty > 1 ? 's' : '';
        summaryEl.textContent = '📦 ' + qty + ' stylo' + plural + ' — $' + perUnit + '/stylo';
      }

      // Find radio buttons — by section ID first, then by container proximity
      var btns = [];
      if (sid) btns = Array.from(document.querySelectorAll('#variant-selects-' + sid + ' input[type=radio]'));
      if (!btns.length) btns = Array.from(container.querySelectorAll('variant-selects input[type=radio], .product-form__input--pill input[type=radio]'));

      if (btns.length && btns[idx]) {
        btns[idx].checked = true;
        btns[idx].dispatchEvent(new Event('change', { bubbles: true }));
      }

      // Update hidden form [name=id] input
      var inp = null;
      if (sid) {
        var form = document.getElementById('product-form-' + sid);
        inp = form && form.querySelector('[name=id]');
      }
      if (!inp) inp = container.querySelector('[name=id]');
      if (!inp) {
        var anyForm = document.querySelector('.product-form');
        inp = anyForm && anyForm.querySelector('[name=id]');
      }
      if (inp && ids[idx]) {
        inp.value = ids[idx];
        inp.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    slider.addEventListener('input', function () { update(this.value); });
    labels.forEach(function (l) {
      l.addEventListener('click', function () {
        slider.value = this.dataset.idx;
        update(this.dataset.idx);
      });
    });

    update(0);
  }

  function initAll() {
    document.querySelectorAll('.pack-variant-wrap').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
